import React, { useRef, useEffect } from "react";
import { shallowEqual, useSelector, connect, useDispatch } from "react-redux";
import * as auth from "./authRedux";
import { getUserByToken } from "./authCrud";

function AuthInit(props) {
  const didRequest = useRef(false);
  const dispatch = useDispatch();
  const { authToken, userId } = useSelector(
    (state) => state.auth,
    shallowEqual
  );

  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const user = await getUserByToken(userId);
          dispatch(props.fulfillUser(user));
        }
      } catch (error) {
        console.error(error);
        if (!didRequest.current) {
          dispatch(props.logout());
        }
      }
    };

    if (authToken) {
      requestUser();
    } else {
      dispatch(props.fulfillUser(undefined));
    }

    return () => {
      didRequest.current = true;
    };
    // eslint-disable-next-line
  }, []);

  return <>{props.children}</>;
}

export default connect(null, auth.actions)(AuthInit);
